import { TextField, Box } from '@mui/material';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';

const InputField = ({ required, type, placeholder, currValue, control, multiline, length }) => {
    let onValueUpdate = (value) => {
        control(value.target.value);
    };
    if (multiline == null) {
        return (
            <Box className={layout.finalizeSectionContainer}>
                <h4 className={typography.finalizeTitle} style={{ textAlign: 'initial' }}>
                    {type}
                    {required && <span style={{ color: 'red' }}> *</span>}
                </h4>
                <TextField
                    style={{ width: '100%' }}
                    type="text"
                    onChange={onValueUpdate}
                    placeholder={placeholder}
                    size="small"
                    value={currValue !== undefined ? currValue : ''}
                    inputProps={{ maxLength: length }}
                />
            </Box>
        );
    } else {
        return (
            <Box className={layout.finalizeSectionContainer}>
                <h4 className={typography.finalizeTitle} style={{ textAlign: 'initial' }}>
                    {type}
                    {required && <span style={{ color: 'red' }}> *</span>}
                </h4>
                <TextField
                    style={{ width: '100%', height: '160px !important' }}
                    type="text"
                    onChange={onValueUpdate}
                    multiline
                    rows={multiline}
                    value={currValue !== undefined ? currValue : ''}
                    placeholder={placeholder}
                    size="small"
                />
            </Box>
        );
    }
};

export default InputField;
